export const radii = {
	xl: '1.5rem',
	sm: '0.5rem',
	none: 0,
	md: '0.75rem',
	lg: '1rem',
	full: '9999px',
};
